import { StatusBar, Style } from '@capacitor/status-bar';
import type { Theme } from './theme';
import { isNativeApp } from './platform';

/**
 * A natív státuszsávot a webes GRUNDO-témához igazítja.
 *
 * ⚠️ A Capacitor `Style` neve a HÁTTÉRRE utal, nem a szövegre: `Style.Dark` =
 * világos szöveg sötét háttérre (iOS `.lightContent`), `Style.Light` = sötét
 * szöveg világos háttérre. 2026-08-23 óta fordítva állt, így sötét témában az
 * idő, a térerő és a wifi sötéten olvashatatlan volt (Geri, 2026-11-02).
 */
export async function syncNativeStatusBar(theme: Theme): Promise<void> {
  if (!isNativeApp()) return;
  await StatusBar.setOverlaysWebView({ overlay: true });
  await StatusBar.setStyle({ style: statusBarStyleFor(theme) });
}

export function statusBarStyleFor(theme: Theme): Style {
  return theme === 'dark' ? Style.Dark : Style.Light;
}
